import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './ChartDataTable.module.scss'

const ChartDataTable = ({ data, columns, caption }) => {
  const [visible, setVisible] = useState(false)

  if (!data || data.length === 0) return null

  return (
    <div className={styles.wrapper}>
      <button
        className={styles.toggle}
        onClick={() => setVisible(v => !v)}
        aria-expanded={visible}
      >
        {visible ? 'Hide data table' : 'Show data table'}
      </button>
      {visible && (
        <table className={styles.table}>
          <caption className={styles.caption}>{caption}</caption>
          <thead>
            <tr>
              {columns.map(col => (
                <th key={col.key} scope='col'>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr key={i}>
                {columns.map(col => (
                  <td key={col.key}>
                    {col.format ? col.format(row[col.key]) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

ChartDataTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    format: PropTypes.func
  })).isRequired,
  caption: PropTypes.string.isRequired
}

export default ChartDataTable
